import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";

//Internal
import { Modal } from "../../components-old/ComponentsIndex";

const QuoteRejectionModal = (props) => {
  const [widthFactor, setWidthFactor] = useState(
    props.quoteRejection.initialWidth ? props.quoteRejection.initialWidth : 100
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setWidthFactor(500);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <Modal
      title={
        props.quoteRejection.modalTitle
          ? props.quoteRejection.modalTitle
          : "Quote Rejection"
      }
      imageUrl=""
      firstActionDesc={
        props.quoteRejection.modalFirstActionDesc
          ? props.quoteRejection.modalFirstActionDesc
          : "Cancel"
      }
      secondActionDesc={
        props.quoteRejection.modalSecondActionDesc
          ? props.quoteRejection.modalSecondActionDesc
          : "Confirm"
      }
      status={props.quoteRejection.openModal}
      handleClose={props.quoteRejection.handleModalClose}
      onSecondActionClick={
        props.quoteRejection.onModalSecondActionClick
          ? props.quoteRejection.onModalSecondActionClick
          : () => {}
      }
    >
      <TextField
        style={{ textAlign: "left", width: widthFactor }}
        multiline
        rows={2}
        label={
          props.quoteRejection.rejectionTextLabel
            ? props.quoteRejection.rejectionTextLabel
            : "Rejection Reason"
        }
        value={props.quoteRejection.rejectionTextVal}
        onChange={props.quoteRejection.handleRejectionTextChange}
      />
    </Modal>
  );
};

export default QuoteRejectionModal;
